export default __webpack_public_path__ + "static/media/bottom_quote.24fcc4ca.svg";